module.exports = __webpack_public_path__ + "img/customer_small.e27c282d.webp";